import { createContext, useContext, useReducer } from 'react';
import { OfficialDiarySearchState, OfficialDiarySearchReducer, ACTION_TYPES } from './official-diary-search-reducer';
import moment from 'moment';
import { IOfficialDiaryPagedRequest } from '../../../../model/sdp/official-daily/request/official-diary-paged-request';

const OfficialDiarySearchContext = createContext<OfficialDiarySearchState | undefined>(undefined);
const OfficialDiarySearchDispatchContext = createContext({} as any);

const OfficialDiarySearchProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: OfficialDiarySearchState = {
        datesParameters: {
            starDatePicker: moment().add(-30, 'd'),
            endDatePicker: moment()
        },
        parameters: {
            startDate: moment().add(-30, 'd').format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            number: undefined,
            statusId: [1],
            types: [1, 2],
            userSenderId: undefined,
            page: 0,
            pageSize: 100
        } as IOfficialDiaryPagedRequest
    };

    const [state, dispatch] = useReducer(OfficialDiarySearchReducer, initialState);

    return (
        <OfficialDiarySearchContext.Provider value={state}>
            <OfficialDiarySearchDispatchContext.Provider value={dispatch}>
                {children}
            </OfficialDiarySearchDispatchContext.Provider>
        </OfficialDiarySearchContext.Provider>
    );
}

const useOfficialDiarySearchState = () => {
    const context = useContext(OfficialDiarySearchContext);
    if (context === undefined) {
        throw new Error('useOfficialDiarySearchState must be used within a OfficialDiarySearchProvider');
    }
    return context;
}

const useOfficialDiarySearchDispatch = () => {
    const context = useContext(OfficialDiarySearchDispatchContext);
    if (context === undefined) {
        throw new Error('useOfficialDiarySearchDispatch must be used within a OfficialDiarySearchProvider');
    }
    return context;
}

export { OfficialDiarySearchProvider, useOfficialDiarySearchDispatch, useOfficialDiarySearchState, ACTION_TYPES };
